import type { Editor } from 'tinymce';

export const versionHistoryPlugin = (editor: Editor, onAction: () => void) => {
  editor.ui.registry.addButton('versionhistory', {
    icon: 'restore-draft',
    tooltip: 'Version History',
    onAction,
  });
};
